import type { KambiSportName, KambiBetOfferCategory } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getPreMatchCategoryForSport(sport: KambiSportName) {
  return simpleFetch<KambiCategoryResponse>(
    `${window._kc.apiOfferingBaseUrl}category/pre_match_event,selected_pre_match/sport/${sport}?lang=en_AU&market=AU`
  )
}

// =====
// Types
// =====

type KambiCategoryResponse = {
  categoryGroups: {
    categories: KambiBetOfferCategory[]
    categoryGroupName: string
  }[]
}
